import request from '@/utils/request'
import { encrypt } from '@/utils/sm2'

// 登录
export function login (username, password) {
  // debugger
  return request({
    url: 'api/admin/login',
    method: 'post',
    params: { username, password }
    // data: {
    //   username,
    //   password
    // }
  })
}

// 获取用户信息
export function getInfo (userinfoId) {
  return request({
    url: '/api/admin/user/current',
    method: 'get',
    params: { userinfoId }
  })
}

// 登出
export function logout () {
  // debugger
  return request({
    url: 'api/admin/logout',
    method: 'get'
  })
}

// 获取菜单权限数据
export function getMenu () {
  return request({
    url: '/admin/acl/index/menu',
    method: 'get'
  })
}

export default {
  // 修改密码
  resetPass (data) {
    return request({
      url: '/api/admin/user/changepassword',
      method: 'get',
      params: {
        phone: data.mobile,
        newpassword: encrypt(data.newPassword),
        msgCode: data.msgCode
      }
    })
  },
  // 短信验证
  messageVerify (mobile, code) {
    return request({
      url: '/api/admin/sms-code/check',
      method: 'GET',
      params: {
        smsCode: code,
        mobile
      }
    })
  },
  // 获取短信验证码
  getMsgCode (mobile, smsCode) {
    return request({
      url: '/api/admin/password/sms-code',
      method: 'GET',
      params: {
        mobile,
        smsCode
      }
    })
  },

  // // 修改密码
  // changePass (data) {
  //   return request({
  //     url: '/api/admin/user/changepassword',
  //     method: 'get',
  //     params: {
  //       phone: data.username,
  //       newpassword: data.psw
  //     }
  //   })
  // }
  GetInfo (mobile, smsCode) {
    return request({
      url: '/api/app/sms/code/check',
      method: 'GET',
      params: {
        mobile,
        smsCode
      }
    })
  },

  // 获取短信验证码
  getMessage (mobile) {
    return request({
      url: '/api/app/sms/code/get',
      method: 'GET',
      params: {
        mobile
      }
    })
  },
  // 微信用户绑定
  getBd (data) {
    return request({
      url: '/api/app/wechat/user/bang-ding',
      method: 'POST',
      data
    })
  },
  // 查询用户id是否已绑定
  GetTrueOpenid (code) {
    return request({
      url: `/api/app/wechat/user/view/${code}`,
      method: 'GET'
    })
  },
  xzdqTree () {
    return request({
      url: '/api/system/area/xzdq/tree',
      method: 'get'
    })
  }
}
